export const clientOptions = {}